<!-- input 文本框 -->
<!--
1. placeholder
2. maxLength
3. allowClear 
4. size 输入框大小
5. type 输入框类型
6. 去除所有空格
-->
<template>
  <div>
    <a-input v-model="targetValue" :type="type" :placeholder="placeholder" :style="inputStyle" :minLength="minLength"
      :maxLength="maxLength" :allowClear="allowClear" :disabled="disabled" @onChange="onChange" @keyup="btKeyUp"
      :size="size" />
  </div>
</template>

<script>
import { trim } from "@/config/utils.js";

export default {
  name: "InputText",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    // 输入框样式
    inputStyle: {
      type: String,
      required: false,
      default: "width: 100%"
    },
    // 输入框类型
    type: {
      type: String,
      required: false,
      default: "text"
    },
    // 输入框的值
    value: {
      type: String | Number
    },
    // 输入框大小
    size: {
      type: String,
      required: false,
      default: "default"
    },
    // 输入框默认的文案
    placeholder: {
      type: String,
      required: false,
      default: "请输入"
    },
    // 最小位数
    minLength: {
      type: Number,
      required: false,
      default: Infinity
    },
    // 最大位数
    maxLength: {
      type: Number,
      required: false,
      default: 150
    },
    // 是否清除
    allowClear: {
      type: Boolean,
      required: false,
      default: true
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    targetValue: {
      get: function () {
        return this.value ? this.trim(this.value) : "";
      },
      set: function (val) {
        this.onChange(val);
      }
    }
  },
  mounted() {

  },
  methods: {
    trim,
    // 输入不能输入空格
    btKeyUp(e) {
      if (e.keyCode == "32") {
        e.target.value = this.trim(e.target.value);
      }
    },
    // 输入框的值改变
    onChange(val) {
      let value = this.trim(val);
      this.$emit("change", value);
    }
  },
  watch: {

  }
};
</script>
      
<style lang="less" scoped>
/deep/ .ant-input-suffix {
  z-index: 0;
}
</style>
      